import React from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';

import UpdateInspectionAgencyEEForm from '../Components/UpdateInspectionAgencyEEForm';

export default function UpdateInspectionAgencyEEPage() {
  return (
    // component="main" 
    <Box sx={{ flexGrow: 1, p: 3 }}>
        <Container>
            <UpdateInspectionAgencyEEForm/>
        </Container>
    </Box>
  )
}
